import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";

function showFatal(error) {
  const root = document.getElementById("root");
  if (!root) return;
  const detail = (error && (error.message || String(error))) || "Unknown error";
  root.innerHTML =
    '<div style="min-height:100vh;display:grid;place-items:center;padding:24px;background:#f4f1ea;color:#0e1116;font-family:Georgia,serif;text-align:center">' +
    '<div style="max-width:560px"><h1 style="font-size:22px;margin:0 0 12px">Wecrew Copilot could not start</h1>' +
    '<p style="color:#6d737d;line-height:1.5;margin:0 0 12px">Try private/incognito window or clear site data for kt.copilot.wecrew.in</p>' +
    `<p style="color:#a9adb3;font-size:12px;font-family:monospace;word-break:break-word;margin:0 0 16px">${detail.replace(/</g, "&lt;")}</p>` +
    '<button type="button" id="wecrew-reload" style="background:#ff5b2e;color:#fff;border:none;border-radius:8px;padding:10px 18px;cursor:pointer">Reload</button></div></div>';
  document.getElementById("wecrew-reload")?.addEventListener("click", () => {
    window.location.href = `${window.location.pathname}?v=${Date.now()}${window.location.hash || "#/app"}`;
  });
}

let booted = false;

function boot() {
  const rootEl = document.getElementById("root");
  if (!rootEl) throw new Error("Missing #root element");
  rootEl.dataset.reactRoot = "1";
  rootEl.textContent = "";
  createRoot(rootEl).render(<App />);
  booted = true;
}

try {
  boot();
} catch (error) {
  console.error("[Wecrew Copilot] boot failed:", error);
  showFatal(error);
}

window.addEventListener("error", (event) => {
  if (!booted) showFatal(event.error || new Error(event.message || "Script error"));
});
window.addEventListener("unhandledrejection", (event) => {
  if (!booted) showFatal(event.reason || new Error("App failed to load"));
});
